
import { isLoadingEndpoint } from 'mega-composable'
import { PropType, computed, defineComponent } from 'vue'
import { contacts } from '@/store/case'
import { trackContact } from '@/core/services/tracking-service'

export default defineComponent({
  props: {
    contactType: { type: String as PropType<'technician' | 'project_manager'>, required: false, default: 'project_manager' }
  },
  setup() {
    const isLoading = isLoadingEndpoint('request/contacts')
    const projectManager = computed(() => contacts.value?.projectManager)

    return {
      trackContact,
      isLoading,
      projectManager
    }
  }
})

